import { createTaskFilterFunction, RunbookFilterType } from './filters'
import { TaskListTask } from 'main/services/queries/types'

export const fixedStart = createTaskFilterFunction('fs', (task: TaskListTask, filters: RunbookFilterType): boolean => {
  const hasFixedStart = (task: TaskListTask): boolean => {
    return typeof task.start_fixed === 'number' && task.start_fixed > 0
  }
  return filters.fs ? hasFixedStart(task) : !hasFixedStart(task)
})
